import has from 'lodash/has';

const dateOptions = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

export default (profile) => {
  if (!has(profile, 'archetype.visitDate')) return null;

  const { visitDate } = profile.archetype;

  return new Date(visitDate).toLocaleDateString('en-US', dateOptions);
};
